import React from 'react';
import PropTypes from 'prop-types';

import ErrorWrapper from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/ErrorWrapper/ErrorWrapper';
import FormErrorHandler from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import TransportType from '../../../../../utility/types/TransportType';
import recipientPropType from '../../../../../utility/PropTypes/recipientPropType';

function NotificationRecipientInput({
  onRecipientChange,
  recipientRowIndex,
  onDeleteBtnPress,
  recipient,
  errorList, users,
}) {
  const contextChange = (event) => {
    const changedRecipient = {
      ...recipient,
      context: event.target.value,
    };
    onRecipientChange(changedRecipient, recipientRowIndex);
  };

  const getRecipientContext = () => {
    if (parseInt(recipient.userId, 10) > 0) {
      const user = users.users.filter((item) => item.userId === recipient.userId)[0];
      if (!user) {
        return '';
      }

      switch (parseInt(recipient.transportId, 10)) {
        case TransportType.EMAIL:
          return (
            <div className="col-sm-auto mb-1 form-inline" style={{ width: '300px' }}>
              <b>{user.emailAddress}</b>
            </div>
          );
        case TransportType.SMS:
          return (
            <div className="col-sm-auto mb-1 form-inline" style={{ width: '300px' }}>
              <b>{!user.smsCountryCode && ('No mobile number configured')}</b>
            </div>
          );
        default:
          return '';
      }
    }

    switch (parseInt(recipient.transportId, 10)) {
      // case TransportType.EMAIL_SMS:
      //   // eslint-disable-next-line no-case-declarations
      //   const providers = wirelessProviderList
      //   .filter((provider) => provider.name !== 'T-Mobile');
      //   // eslint-disable-next-line no-case-declarations
      //   const recipientJson = JSON.parse(recipient.context);
      //   return (
      //     <>
      //       <div className="col-auto mb-1">
      //         <select
      //           name="provider"
      //           className="form-control always-inline"
      //           value={recipientJson.provider}
      //           onChange={providerChange}
      //         >
      //           <option value="">Choose a provider</option>
      //           {providers.map((provider, index) => (
      //             <option key={index} value={provider.value}>
      //               {provider.name}
      //             </option>
      //           ))}
      //         </select>
      //       </div>
      //       <div className="col-sm-auto mb-1" style={{ width: '250px' }}>
      //         <input
      //           type="text"
      //           aria-label="recipient email-to-sms address"
      //           placeholder="1234567890"
      //           className="form-control"
      //           value={recipientJson.number}
      //           onChange={numberChange}
      //         />
      //       </div>
      //     </>
      //   );
      case TransportType.EMAIL:
        return (
          <div className="col-sm-auto mb-1" style={{ width: '300px' }}>
            <input
              type="text"
              aria-label="recipient email address"
              placeholder="recipient@example.com"
              className="form-control"
              value={recipient.context}
              onChange={contextChange}
            />
          </div>
        );
      case TransportType.WEBHOOK:
        return (
          <div className="col-sm-auto mb-1" style={{ width: '300px' }}>
            <input
              type="text"
              aria-label="url"
              placeholder="http://myservice.com"
              className="form-control"
              value={recipient.context}
              onChange={contextChange}
            />
          </div>
        );
      default:
        return '';
    }
  };

  const transportIdChange = (event) => {
    const changedRecipient = {
      ...recipient,
      transportId: event.target.value,
      context: '',
    };
    onRecipientChange(changedRecipient, recipientRowIndex);
  };

  const userIdChange = (event) => {
    const { value } = event.target;
    const changedRecipient = {
      ...recipient,
      userId: value !== '-1' ? value : null,
      context: '',
      transportId: '0',
    };
    onRecipientChange(changedRecipient, recipientRowIndex);
  };

  const deleteBtnPress = () => {
    onDeleteBtnPress(recipientRowIndex);
  };

  return (
    <>
      <FormErrorHandler
        errorList={errorList}
      >
        <ErrorWrapper fieldId={`contextContactType[${recipientRowIndex}]`}>
          <>
            <div className="col-sm-auto mb-1" style={{ lineHeight: 'calc(1.5em + .75rem + 2px)' }}>Notify</div>
            <div className="col-sm-auto mb-1">
              <select
                value={recipient.userId !== null ? recipient.userId : -1}
                aria-label="Choose a recipient"
                className="form-control"
                onChange={userIdChange}
                defaultValue={0}
              >
                <option value={0} disabled>- Choose a recipient -</option>
                {users.users.map((user) => (
                  <option key={`user${user.userId}`} value={user.userId}>
                    {user.firstName}
                            &nbsp;
                    {user.lastName}
                  </option>
                ))}
                <option value={-1}>- Other -</option>
              </select>
            </div>

            {recipient.userId !== 0 && (
              <div className="col-sm-auto mb-1">
                <select
                  value={recipient.transportId}
                  aria-label="Pick a notification method"
                  className="form-control"
                  onChange={transportIdChange}
                >
                  <option value="0" disabled>- Pick a notification method -</option>
                  <option value={TransportType.EMAIL}>
                    {recipient.userId > 0 ? 'Email address on file' : 'Send an email'}
                  </option>
                  {recipient.userId > 0 ? (
                    <>
                      <option value={TransportType.IN_APP}>Send a mobile push notification</option>
                      <option value={TransportType.SMS}>Text phone number on file</option>
                    </>
                  ) : (
                    <>
                      <option value={TransportType.WEBHOOK}>Send a HTTP post</option>
                      {/* <option value={TransportType.EMAIL_SMS}>Send an email-to-SMS</option> */}
                    </>
                  )}
                </select>
              </div>
            )}
            {getRecipientContext(recipient)}
            <div className="col-sm-auto ml-auto mb-1 text-right">
              <button type="button" className="btn" onClick={deleteBtnPress} aria-label="delete">
                <Icon icon="trash-can" />
              </button>
            </div>
          </>
        </ErrorWrapper>
      </FormErrorHandler>
    </>

  );
}

NotificationRecipientInput.defaultProps = {
  recipient: {
    id: 0,
    transportId: '0',
    context: '',
    userId: 0,
  },
  users: null,
};

NotificationRecipientInput.propTypes = {
  onRecipientChange: PropTypes.func.isRequired,
  onDeleteBtnPress: PropTypes.func.isRequired,
  recipient: PropTypes.shape(recipientPropType),
  recipientRowIndex: PropTypes.number.isRequired,
  errorList: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    message: PropTypes.string,
  })).isRequired,
  users: PropTypes.shape({
    users: PropTypes.arrayOf(
      PropTypes.shape({
        userId: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        emailAddress: PropTypes.string,
        roleId: PropTypes.string,
      }),
    ),
  }),
};

export default NotificationRecipientInput;
